<template>
  <div class="contact-main-block w-100 relative">
    <HeaderMenu
      :title="title"
      :routeBackName="routeBackName"
      :class="{ 'mrg-b-30': !$store.state.hasInternet }"
    />
    <div v-if="$store.state.hasInternet">
      <!--   <div class="waiting" v-if="waiting">
        <div class="text-color text-larg">{{ this.$t("support.waiting") }}</div>
        <spinnerCircle />
      </div> -->
      <div class="contact-support-team">
        <div class="contact-support">
          <div class="mrg-b-6 bold">
            {{ this.$t("support.contactSupport") }}
          </div>
          <div>02-5866078 | otzar@otzar.biz</div>
          <button
            v-remove.online
            @click="openErrorsLog"
            class="center btn btn-w-larg"
          >
            {{ $t("support.openLogFile") }}
          </button>
          <button
            v-kiosk
            v-remove.online
            @click="openTV"
            class="center btn btn-w-larg"
          >
            {{ $t("support.openTV") }}
          </button>
          <div class="waiting" v-if="waiting">
            <div class="text-color text-larg">
              {{ this.$t("support.waiting") }}
            </div>
            <spinnerCircle />
          </div>
        </div>
        <!-- <div v-remove.online>
          <div>מסור מספר זה לתמיכה:</div>
          <div class="code-support bold">{{ code }}</div>
        </div> -->
        <div v-remove.offline>
          <form :action="'mailto:otzar@otzar.biz'">
            <input
              type="hidden"
              name="Subject"
              value="פניה בענין האתר המקוון"
            />
            <input type="hidden" name="Body" value="" />
            <button @click="sendMail" class="center btn btn-w-larg">
              כתוב לנו
            </button>
            <!-- <input
              type="submit"
              class="center btn btn-w-larg"
              value="כתוב לנו"
            /> -->
          </form>
          <button @click="downloadTeamViewer" class="center btn btn-w-larg">
            הורדת תוכנת חיבור מרחוק
          </button>
        </div>
      </div>
    </div>
    <div class="contact-support" v-else>
      <div class="mrg-b-6 bold">{{ this.$t("support.contactSupport") }}</div>
      <div>02-5866078 | otzar@otzar.biz</div>
      <button
        v-remove.online
        @click="openErrorsLog"
        class="center btn btn-w-larg"
      >
        {{ $t("support.openLogFile") }}
      </button>
    </div>
  </div>
</template>

<script>
// import menuService from "../../../../services/menu";
// import * as userSendEmail from "@/services/userSendEmail.js";
import { launchApp } from "@/services/general.js";
export default {
  sockets: {
    connect: function () {},
    tvcode: function (code) {
      this.waiting = false;
      this.code = code.trim();
    },
  },
  data() {
    return {
      title: this.$t("mainMenu.support"),
      routeBackName: "main",
      waiting: globalThis.SERVER_MODE == "offline",
      code: "",
    };
  },
  methods: {
    async openTV() {
      this.waiting = true;
      this.$nextTick(async () => {
        await launchApp("%CURRENT_DRIVE%\\tv_144.exe");
        this.waiting = false;
      });
    },
    downloadTeamViewer() {
      //('../teamvieweroh.exe')

      if (globalThis.SERVER_MODE === "offline")
        launchApp("%CURRENT_DRIVE%\\utils\\TeamViewerQS_he-idcthfxpqu.exe");
      else
        window.open(
          location.protocol + "//" + location.host + "/static/tv_144.exe"
        );
    },
    sendMail() {
      const body = "";
      const subject = "פניה בענין האתר המקוון";

      window.location.replace(
        `mailto:otzar@otzar.biz?body=${body}&subject=${subject} wants to contact you`
      );
    },
    async openErrorsLog() {
      if (!(await globalThis.OPEN_ERROR_LOG())) {
        const notification = {
          type: "error",
          message: this.$t("support.noFileMsg"),
          timeout: 2000,
        };
        this.$notify(notification);
      }
    },
  },
  created() {
    //disable tv for now
    this.waiting = false;
    //if we had internet then try to get the tv info
    if (this.$store.state.hasInternet) {
      //run tv and wait for code
      // if (globalThis.SERVER_MODE == "offline")
      //   this.$socket.client.emit("getTvCode");
    }
  },
};
</script>

<style lang="scss" scoped>
$bg-color2: #f7f7f7;
$bg-color5: #f4f4f4;
.colum1 {
  .row {
    margin-bottom: 12px;
  }
}
.contact-main-block {
  // overflow-y: scroll;
  // overflow-x: hidden;
}
.go-to-company-staff-block {
  display: flex;
  margin-top: auto;
  height: 60px;
  background-color: $bg-color5;
  border-top: 1px solid #dedede;
  height: 60px;
  background-color: $bg-color5;
  border: 1px solid #dedede;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  bottom: 0;
  justify-content: space-between;
  p {
    margin: 0;
    line-height: 60px;
    font-weight: bold;
  }
}
.go-to-comp-staff-btn {
  width: auto;
  padding: 0 10px;
  // margin: 3px 0;
  // margin-right: auto;
}
.company-details-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .company-location-block {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    padding-right: 20px;
    .company-location {
      display: flex;
      flex-direction: column;
      line-height: 0px;
      p {
        margin: 0;
        line-height: 18px;
        font-size: 13px;
      }
    }
    .icon-location {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
  }
  .company-activity-block {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    padding-right: 20px;
    .icon-activity {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
    .company-activity {
      display: flex;
      flex-direction: column;
      line-height: 0px;
    }
    p {
      margin: 0;
      line-height: 18px;
      font-size: 13px;
    }
  }
  .company-contant-block {
    display: flex;
    justify-content: flex-start;
    padding-right: 20px;
    margin-bottom: 30px;
    .icon-contant {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
    .company-contant {
      display: flex;
      flex-direction: column;
      line-height: 0px;
    }
    p {
      margin: 0;
      line-height: 18px;
      font-size: 13px;
    }
  }
}
.email-error {
  color: red;
  padding: 0 20px;
}

.contact-container {
  display: flex;
  padding: 0px 10px 0px 10px;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  padding: 34px 20px 0px;
  input.input-border.filled + span {
    margin-bottom: 20px !important;
  }
  input.input-border.filled + span span {
    height: 14px;
    line-height: 14px;
    font-size: 10px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.3);
  }
  .input-border.filled:focus + span span {
    color: var(--custom-color1);
  }
}
.input-data {
  width: 90%;
  display: flex;
  border: none;
  //margin: 0px 4px 0px 0px;
  border-bottom: 1px solid #afafaf;
  background: none;
  padding: 0;
  margin-left: 18px;
  //width: -webkit-fill-available;
}

.send-block {
  display: flex;
  justify-content: space-between;
  margin: 0 6px;
}
.send-email {
  margin-right: auto;
  margin-left: 20px;
}
.text-area-container {
  padding: 0 20px 0;
  p {
    margin: 0;
    font-weight: 300;
    color: var(--custom-color1);
    font-size: 12px;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .inputs-data-bloke {
    resize: none;
    width: 97%;
    height: 150px;
    // margin: 6px;
    line-height: 20px;
    background-color: $bg-color2;
    // margin-top: 3px;
    border: 1px solid #afafaf;
    // margin-bottom: 13px;
    &::placeholder {
      color: var(--text-color3) !important;
    }
  }
}
.waiting {
  display: flex;
  justify-content: center;
  font-weight: bold;
  padding-top: 40px;
  font-size: 32px;
}
.contact-support-team {
  //     display: flex;
  //   justify-content: center;
  //   font-weight: bold;
  padding-top: 40px;
  //   font-size: 32px;
  text-align: center;
  color: var(--custom-color1);
  &.code-support {
    font-size: 22px;
  }
}
.contact-support {
  display: flex;
  justify-content: center;
  //   font-weight: bold;
  padding-top: 50px;
  font-size: 16px;
  flex-direction: column;
  align-items: center;
  color: var(--custom-color2);
}
</style>
